<template>
  <div>
    <v-row>
      <v-col cols="12" class="text-center">
        دوره های شما :
      </v-col>
      <v-col cols="12">
        <v-card class="my-4 mx-8 custom-rounded" elevation="1" color="#1ab69d" v-for="course in courses"
                :key="course.course.id">
          <v-card-title class="white--text">
            {{ course.course.title }}
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" class="white--text">
                <img class="rounded" width="100%" height="250px" :src="course.course.cover_file" :alt="course.course.title"/>
              </v-col>
              <v-col cols="12" class="white--text">
                {{ course.course.details }}
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" class="text-center">
        مربیان شما :
      </v-col>
      <v-col cols="12">
        <v-card class="my-4 mx-8 custom-rounded" elevation="1" color="#1ab69d" v-for="instructor in instructors"
                :key="instructor.instructor.id">
          <v-card-title class="white--text">
            <v-row>
              <v-col cols="7">
                <v-row>
                  <v-col cols="12" class="small-text-custom mb-0 pb-0">
                    {{ instructor.instructor.name }}
                  </v-col>
                  <v-col cols="12" class="x-small-text-custom mt-o pt-0">
                    {{ instructor.instructor.email }}
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="5">
                <img class="rounded" width="100%" height="100px" :src="instructor.instructor.profile_image"
                     :alt="instructor.instructor.name"/>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" class="white--text">
                {{ instructor.instructor.details }}
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

    </v-row>
  </div>
</template>

<script>
export default {
  name: "CoursesAndInstructorsMobile",
  data() {
    return {
      courses: [],
      instructors: []
    }
  },
  mounted() {
    this.getDetails()
  },
  methods: {
    getDetails() {
      window.axios.get('student/details/courses-instructors').then((res) => {
        this.courses = res.data.data.course_details
        this.instructors = res.data.data.instructor_details
      })
    }
  }
}
</script>

<style scoped>
.custom-rounded {
  border-radius: 20px !important;
}

.small-text-custom {
  font-size: 4vw;
}

.x-small-text-custom {
  font-size: 3.1vw;
}
</style>